const LogsAdmin = () =>
  <>
    You must be logged in with administrator privileges to download logs.
  </>

export default LogsAdmin
